import { NgModule, ModuleWithProviders } from '@angular/core';
import { MarkdownComponent } from './markdown.component';
import { NgxMdModule } from 'ngx-md';
import { HttpClientModule } from '@angular/common/http';

export const forRoot: ModuleWithProviders<NgxMdModule> = NgxMdModule.forRoot()
@NgModule({
  imports: [
    forRoot,
    HttpClientModule
  ],
  declarations: [
    MarkdownComponent
  ],
  exports: [
    MarkdownComponent
  ]
})
export class MarkdownModule {}
